




























































import Vue from "vue";
import { PuzzleListItem } from "vue/types/vue";
import { PuzzleService } from "../../services/puzzleservice";
export default Vue.extend({
  name: "AdminPuzzleItem",
  props: {
    puzzle: {
      type: Object as () => PuzzleListItem,
      default: {} as () => PuzzleListItem,
    },
  },
  data() {
    return {
      modalHeader: "",
      modalMessage: "",
      selectedPuzzleId: "",
      show: false,
    };
  },
  methods: {
    deletePuzzle: function (puzzleName: string, puzzleid: string): void {
      this.$emit("deletePuzzle", { name: puzzleName, id: puzzleid });
    },
    confirmDelete: async function (choice: boolean): Promise<void> {
      this.closeModal();
      try {
        if (choice) {
          await PuzzleService.deletePuzzle(this.selectedPuzzleId);
          window.location.reload();
        }
      } catch (error: any) {
        console.log(error);
      }
    },
    closeModal: function (): void {
      this.modalHeader = "";
      this.modalMessage = "";
    },
  },
});
